<template>
  <global-modal name="event-modal-catalog-rubrics" @before-open="beforeOpen">
    <Modal :back="true" :mini="true" @close="onModalClose">
      <div class="event-modal-catalog-rubrics">
        <div class="event-modal-catalog-rubrics__container">
          <h1 class="event-modal-catalog-rubrics__title">
            {{ $t("event.catalog.modal.rubricsSelect.title") }}
          </h1>

          <p class="event-modal-catalog-rubrics__text">
            {{ $t("event.catalog.modal.rubricsSelect.freeNote") }}
            {{ freeRubricsCount }}

            {{
              freeRubricsCount
                | pluralize(
                  $t("event.catalog.modal.rubricsSelect.freeNotePluralize")
                )
            }}
          </p>
        </div>

        <div class="event-modal-catalog-rubrics__container">
          <button
            class="event-modal-catalog-rubrics__print-rubrics event-modal-catalog-rubrics__print-rubrics--top"
            @click="printRubrics"
          >
            <icon name="print" />
            {{ $t("event.catalog.modal.rubricsSelect.printRubrics") }}
          </button>

          <SearchField
            :placeholder="
              $t('event.catalog.modal.rubricsSelect.searchPlaceholder')
            "
            class="event-modal-catalog-rubrics__search"
            v-model="searchText"
          />

          <template v-if="rubricsBySearch.length">
            <div
              class="event-modal-catalog-rubrics__rubric-content-item"
              v-for="item in rubricsBySearch"
              :key="item.id"
            >
              <Checkbox
                v-model="rubricsModel[item.id]"
                :disabled="!item.is_selected"
              >
                {{ i18n.locale === "en" ? item.name_eng : item.name_rus }}
              </Checkbox>
            </div>
          </template>

          <template v-if="rubricsBySearch.length === 0">
            <div
              class="event-modal-catalog-rubrics__rubric"
              v-for="rubric in rubricsList"
              :key="rubric.id"
            >
              <div
                class="event-modal-catalog-rubrics__rubric-header"
                @click="toggleRubric(rubric)"
              >
                <div
                  class="event-modal-catalog-rubrics__rubric-header-checkbox"
                >
                  <Checkbox
                    v-model="rubricsModel[rubric.id]"
                    :disabled="!rubric.is_selected"
                  />

                  <span
                    class="event-modal-catalog-rubrics__rubric-header-checkbox-text"
                  >
                    {{ rubric.code }}.
                    {{
                      i18n.locale === "en" ? rubric.name_eng : rubric.name_rus
                    }}
                  </span>
                </div>

                <span
                  class="event-modal-catalog-rubrics__rubric-header-count"
                  v-if="countSelected(rubric)"
                >
                  {{ countSelected(rubric) }}
                </span>

                <div
                  class="event-modal-catalog-rubrics__rubric-header-toggle"
                  v-if="rubric.children?.length"
                >
                  <icon
                    name="arrow-down"
                    :class="{ _rotated: rubricOpened === rubric.id }"
                  />
                </div>
              </div>

              <div
                class="event-modal-catalog-rubrics__rubric-content"
                v-if="rubric.children?.length && rubricOpened === rubric.id"
              >
                <div
                  class="event-modal-catalog-rubrics__rubric-content-item"
                  v-for="inner in rubric.children"
                  :key="inner.id"
                >
                  <Checkbox
                    v-model="rubricsModel[inner.id]"
                    :disabled="!inner.is_selected"
                  >
                    {{ inner.code }}.
                    {{ i18n.locale === "en" ? inner.name_eng : inner.name_rus }}
                  </Checkbox>

                  <template v-if="inner.children?.length">
                    <template v-for="sub in inner.children">
                      <div
                        v-if="sub"
                        :key="sub.id"
                        class="event-modal-catalog-rubrics__rubric-content-item"
                      >
                        <Checkbox
                          v-model="rubricsModel[sub.id]"
                          :disabled="!sub.is_selected"
                        >
                          {{ sub.code }}.
                          {{
                            i18n.locale === "en" ? sub.name_eng : sub.name_rus
                          }}
                        </Checkbox>

                        <template v-if="sub.children?.length">
                          <template v-for="fourthSub in sub.children">
                            <div
                              v-if="fourthSub"
                              :key="fourthSub.id"
                              class="event-modal-catalog-rubrics__rubric-content-item"
                            >
                              <Checkbox
                                v-model="rubricsModel[fourthSub.id]"
                                :disabled="!fourthSub.is_selected"
                              >
                                {{ fourthSub.code }}.
                                {{
                                  i18n.locale === "en"
                                    ? fourthSub.name_eng
                                    : fourthSub.name_rus
                                }}
                              </Checkbox>

                              <template v-if="fourthSub.children?.length">
                                <template
                                  v-for="fifthSub in fourthSub.children"
                                >
                                  <div
                                    v-if="fifthSub"
                                    :key="fifthSub.id"
                                    class="event-modal-catalog-rubrics__rubric-content-item"
                                  >
                                    <Checkbox
                                      v-model="rubricsModel[fifthSub.id]"
                                      :disabled="!fifthSub.is_selected"
                                    >
                                      {{ fifthSub.code }}.
                                      {{
                                        i18n.locale === "en"
                                          ? fifthSub.name_eng
                                          : fifthSub.name_rus
                                      }}
                                    </Checkbox>
                                  </div>
                                </template>
                              </template>
                            </div>
                          </template>
                        </template>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div
          v-if="rubricsList?.length"
          class="event-modal-catalog-rubrics__suggest-rubric-link event-modal-catalog-rubrics__container"
        >
          <button
            class="event-modal-catalog-rubrics__print-rubrics"
            @click="printRubrics"
          >
            <icon name="print" />
            {{ $t("event.catalog.modal.rubricsSelect.printRubrics") }}
          </button>
        </div>

        <footer class="event-modal-catalog-rubrics__footer">
          <div class="event-modal-catalog-rubrics__container">
            <ul class="event-modal-catalog-rubrics__footer-list">
              <li class="event-modal-catalog-rubrics__footer-list-item">
                <span>{{
                  $t(
                    "event.catalog.modal.rubricsSelect.footerAllRubricsSelected"
                  )
                }}</span>
                {{ selectedRubricsCount }}
              </li>

              <li class="event-modal-catalog-rubrics__footer-list-item">
                <span>{{
                  $t(
                    "event.catalog.modal.rubricsSelect.footerPaidRubricsSelected"
                  )
                }}</span>
                {{ Math.max(selectedRubricsCount - freeRubricsCount, 0) }}
              </li>
            </ul>

            <PrimaryButton
              :disabled="selectedRubricsCount === 0"
              @click="selectRubrics"
            >
              {{ $t("event.catalog.modal.rubricsSelect.footerSelectBtn") }}
            </PrimaryButton>
          </div>
        </footer>
      </div>
    </Modal>
  </global-modal>
</template>

<script>
import { mapGetters } from "vuex";
import printJS from "print-js";
import apiCatalog from "@/api/catalog";
import Modal from "@/components/Modal/Modal.vue";
import { PrimaryButton, SearchField, Checkbox } from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";

function isStrContains(str1, str2) {
  return str1.toLowerCase().indexOf(str2.toLowerCase()) !== -1;
}

function searchRubrics(text, rubrics) {
  let output = [];

  rubrics.forEach(rubric => {
    if (
      isStrContains(
        i18n.locale === "en" ? rubric.name_eng : rubric.name_rus,
        text
      )
    ) {
      output.push(rubric);
    }

    if (rubric.children) {
      output = [...output, ...searchRubrics(text, rubric.children)];
    }
  });

  return output;
}

export default {
  name: "EventModalCatalogRubrics",

  components: {
    Modal,
    SearchField,
    Checkbox,
    PrimaryButton
  },

  data() {
    return {
      searchText: "",
      rubricsModel: {},
      rubricOpened: "",

      i18n: i18n
    };
  },

  computed: {
    ...mapGetters("eventCatalog", [
      "freeRubricsCount",
      "additionalRubricPrice",
      "rubricsList"
    ]),

    ...mapGetters("event", ["eventId"]),

    selectedRubricsCount() {
      return this.selectedRubricsId.length;
    },

    selectedRubricsId() {
      return Object.keys(this.rubricsModel).filter(id => this.rubricsModel[id]);
    },

    rubricsBySearch() {
      return this.searchText
        ? searchRubrics(this.searchText, this.rubricsList)
        : [];
    }
  },

  methods: {
    countSelected(item) {
      let count = 0;

      if (this.rubricsModel[item.id]) {
        count++;
      }

      if (item.content) {
        item.content.forEach(x => {
          count += this.countSelected(x);
        });
      }

      return count;
    },

    selectRubrics() {
      const newRubricsId = (() => {
        const { selectedRubricsId } = this.$store.state.eventCatalog;

        return this.selectedRubricsId.filter(
          id => selectedRubricsId.indexOf(id) === -1
        );
      })();

      this.$store.dispatch(
        "eventCatalog/updateRubrics",
        this.selectedRubricsId
      );
      // для каждой новой рубрики включаем услугу "краткая информация"
      const shortInfoServiceId = this.$store.getters[
        "eventCatalog/shortInfoRubricServiceId"
      ];

      if (shortInfoServiceId) {
        newRubricsId.forEach(rubricId => {
          this.$store.dispatch("eventCatalog/updateServiceForRubric", {
            rubricId,
            serviceId: shortInfoServiceId,
            value: true
          });
        });
      }

      this.$modal.hide("event-modal-catalog-rubrics");
    },

    beforeOpen() {
      const { selectedRubricsId } = this.$store.state.eventCatalog;

      this.rubricsModel = selectedRubricsId.reduce((acc, id) => {
        acc[id] = true;

        return acc;
      }, {});
    },

    async printRubrics() {
      const response = await apiCatalog.downloadRubrics(this.eventId);
      let blob = new Blob([response], {
        type: "application/pdf"
      });
      const url = window.URL.createObjectURL(blob);
      printJS(url);
    },

    toggleRubric(rubric) {
      if (this.rubricOpened === rubric.id) {
        this.rubricOpened = null;
      } else {
        this.rubricOpened = rubric.id;
      }
    },

    onModalClose() {
      this.$modal.hide("event-modal-catalog-rubrics");
      setTimeout(function() {
        document.body.setAttribute("data-modal-count", 1);
        document.body.classList.add("_overflow_hidden");
      }, 200);
    }
  },

  created() {
    this.searchText = "";
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-catalog-rubrics {
  padding-top: 55px;

  height: 100vh;
  overflow-y: scroll;

  box-sizing: border-box;

  @include respond-down(lg) {
    height: 100%;
  }

  @include respond-down(md) {
    padding-top: 28px;
  }

  &__container {
    width: 700px;
    padding-left: 80px;

    @include respond-down(lg) {
      max-width: 720px + 24 * 2px;
      width: 100%;

      padding: 0 24px;

      box-sizing: border-box;
    }

    @include respond-down(md) {
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  &__title {
    @include h1();
    margin-bottom: 34px;
    @include respond-down(md) {
      margin-bottom: 24px;
    }
  }

  &__text {
    @include description();
    margin-bottom: 17px;
  }

  &__suggest-rubric-link {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-content: flex-start;
    align-items: center;
    margin-top: 30px;
  }

  &__print-rubrics {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: center;
    margin: 10px 0;
    padding: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    background-color: transparent;
    border: none;
    box-shadow: none;
    outline: none;
    color: #009ee3;
    cursor: pointer;

    @media (max-width: 739px) {
      font-size: 12px;
    }
    &--top {
      margin-top: 44px;
    }
    .svg-icon {
      max-width: 18px;
      max-height: 18px;
      margin-right: 10px;

      @media (max-width: 739px) {
        max-width: 16px;
        max-height: 16px;
      }
    }
  }

  &__suggest {
    margin-top: -32px;
    margin-bottom: -70px;

    background: rgba(#f9f9f9, 0.5);

    border-top: 2px solid #f1f1f1;
    border-bottom: 2px solid #f1f1f1;

    padding: 47px 0 48px 0;

    @include respond-down(md) {
      padding: 32px 0 32px 0;
    }

    &-title {
      @include description();

      display: flex;
      align-items: flex-start;

      margin-bottom: 20px;

      &-close {
        @include button-clean();

        margin-top: 5px;
        margin-left: 23px;

        .svg-icon {
          width: 16px;
          height: 16px;
        }
      }
    }

    &-input {
      width: 530px;

      @include respond-down(md) {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }

  &__suggest &__container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__search {
    margin-top: 30px;
    margin-bottom: 16px;

    width: 100%;
  }

  &__rubric {
    border-top: 1px solid rgba(205, 206, 208, 0.5);
    border-bottom: 1px solid rgba(205, 206, 208, 0.5);

    margin-top: -1px;

    @include respond-down(md) {
      margin-left: -16px;
      width: calc(100% + 2 * 16px);
    }

    &-header {
      display: flex;
      align-items: center;

      padding: 23px 23px 23px 0;
      cursor: pointer;

      @include respond-down(md) {
        padding-right: 16px;
        padding-left: 16px;
      }

      &-checkbox {
        display: flex;
        align-items: flex-start;

        margin-right: auto;

        &-text {
          position: relative;
          top: 3px;

          line-height: 1.6;

          cursor: pointer;

          @include respond-down(md) {
            font-size: 12px;
          }
        }
      }

      &-count {
        color: #0070d2;
        font-size: 14px;
        font-weight: 500;
        margin-left: 20px;

        @include respond-down(md) {
          font-size: 12px;
          margin-left: 8px;

          align-self: flex-start;
          transform: translateY(7px);
        }
      }

      &-toggle {
        margin-left: 8px;

        .svg-icon {
          width: 16px;
          height: 16px;

          &._rotated {
            transform: rotate(-180deg);
          }
        }

        @include respond-down(md) {
          align-self: flex-start;

          transform: translateY(5px);
        }
      }
    }

    &-content {
      border-top: 1px solid rgba(205, 206, 208, 0.3);

      /*margin-top: 23px;*/
      padding-bottom: 22px;

      &-item {
        padding-top: 23px;

        @include respond-down(md) {
          padding-right: 16px;
          padding-left: 16px;
        }
      }

      &-item > &-item {
        padding-left: 37px;
      }
    }
  }

  &__footer {
    position: sticky;
    bottom: 0;

    border-top: 2px solid #f1f1f1;
    margin-top: 65px;

    padding: 18px 0;

    background: #fff;

    &-list {
      display: flex;

      list-style: none;

      padding: 0;
      margin: 0;

      margin-right: auto;

      &-item {
        @include description();

        span {
          color: #000;
        }

        margin-right: 40px;
      }
    }
  }

  &__footer &__container {
    display: flex;
    align-items: center;
  }
}
</style>

<style lang="scss">
.event-modal-catalog-rubrics {
  &__suggest-rubric-link {
    .link-icon {
      margin-right: 30px;
    }
  }
}
</style>
